// DropDownMenu uses min-width:0 and CustomTooltip is inline-block. Without a
// real flex item (not display:contents) the triggers collapse and overlap.
export const fxWorkspaceDropdownSlotClass =
  'relative min-w-0 flex-1 [&_.dropdown-pane-container]:w-full [&_.dropdown-pane-container]:max-w-full [&_.dropdown-pane-container>div]:w-full [&_.dropdown-pane-container>div]:max-w-full [&_button]:w-full [&_button]:max-w-full';
